import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../database/useQueries';
import FormTemplate from '../../template/form/FormTemplate';
import { useSelector } from 'react-redux';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { CommponentOptions, getFieldOptions } from '../plagins/data/commponentOptions';
import { Button } from '@mui/material';
import RowCreate from '../pagesCreate/rowCreate';
import CustomDialog from '../plagins/dialogs/customDialog';
import { GlobalContext } from '../../../App';
import { v4 as uuidv4 } from 'uuid';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { addRecordToCache, createFetchDataServer, createFetchDataServerWithCallback, deleteRecordFromCache, getTableData, updateRecordInCache } from '../../../database/fetchData';
import { fullSelectedAreaGraves, fullSelectedBlocks, fullSelectedCemeteries, fullSelectedPlots, fullSelectedRows } from '../plagins/data/multiSelectedForm';
import { isAction } from '@reduxjs/toolkit';

const NAME_ENTITY = 'אחוזת קבר';

function GraveUpdate() {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columnStore = useSelector((state) => state.columnsFormAreaGraves.data);
  const columns = useSelector((state) => state.columnsFormAreaGraves.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataAreaGrave, getEntitiesByAttr, getEntityByAttr } = useQueries();

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();
  const { value } = location.state || {};

  const { setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`עדכון אחוזת קבר`);
  }, [location.pathname]);

  // משתנים לערכי סלקט של השדות
  const [cemeteries, setCemeteries] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [plots, setPlots] = useState([]);
  const [rows, setRows] = useState([]);
  const [areaGraves, setAreaGraves] = useState([]);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true); // מצב טעינה
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);

  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns;
    return localColumns.map((field, index) => {
      return {
        ...field,
        disabled: field.disabled && myAreaGrave !== undefined,
        required: field.required || false,
        show: field?.show || false
      };
    });
  };

  const [myAreaGrave, setMyAreaGrave] = useState(context?.contextAreaGraves?.find((item) => item?.unicId === value?.unicId) || value);
  useEffect(() => {
    setMyAreaGrave(context?.contextAreaGraves?.find((item) => item?.unicId === value?.unicId) || value);
  }, [context?.contextAreaGraves]);

  // טעינת ערכים אוטומטית לשדות
  const fieldAuto = (data) => {
    setCemeteries(fullSelectedCemeteries(context?.contextCemeteries));
    setBlocks(fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', data?.cemeteryId)));
    setPlots(fullSelectedPlots(getEntitiesByAttr(context?.contextPlots, 'blockId', data?.blockId)));
    setRows(fullSelectedRows(getEntitiesByAttr(context?.contextRows, 'plotId', data?.plotId), true, setOpen));
    setAreaGraves(getEntitiesByAttr(context?.contextAreaGraves, 'lineId', data?.lineId));
  };

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    console.log(90, myAreaGrave);

    if (myAreaGrave?.unicId) {
      let data = myAreaGrave;
      // פונקציה להשוואת ערכים לפי קוד ה-UTF-16 של האותיות העבריות עם בדיקה מקדימה
      const compareHebrewLetters = (a, b) => {
        return (a.graveNameHe ? a.graveNameHe.charCodeAt(0) : 0) - (b.graveNameHe ? b.graveNameHe.charCodeAt(0) : 0);
      };
      // השדות של הקברים שמתווספים
      let columnsGraves = [];
      let graves = getEntitiesByAttr(context?.contextGraves, 'areaGraveId', myAreaGrave?.unicId);

      // מיון המערך לפי האטריביוט areaGraveNameHe
      graves?.sort(compareHebrewLetters);

      graves?.map((grave, index) => {
        const newColumn = {
          id: grave?.id,
          name: `floor${index}`,
          graveNameHe: grave?.graveNameHe,
          required: true,
          width: 800,
          show: true,
          input: 'floors',
          notRepeat: true
        };
        columnsGraves = [...columnsGraves, newColumn];
        data = {
          ...data,
          [`floor${index}`]: { id: grave?.id, unicId: grave?.unicId, plotType: grave?.plotType, graveNameHe: grave?.graveNameHe, ...grave }
        };
      });

      console.log(123, graves);

      const allColumns = [...columns, ...columnsGraves];

      setFieldsWithDynamicDisabled(myColumns(allColumns));

      let initialFormValues = myColumns(allColumns)
        .filter((field) => field?.name)
        .reduce(
          (acc, field) => {
            let fieldValue = data[field.name] || '';

            return {
              ...acc,
              [field.name]: fieldValue
            };
          },
          {
            id: data?.id,
            unicId: data?.unicId
          }
        );

      console.log(144, initialFormValues);

      fieldAuto(myAreaGrave);

      setFormValues(initialFormValues); // newValues הם הערכים החדשים שברצונך לעדכן
    }
  };

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    !loading && handleAllDataLoaded();
  }, [loading, navigator.onLine, context?.contextAreaGraves, context?.contextGraves]);
  const fieldChangeCemeteryId = (event, newFormValues) => {
    delete newFormValues?.blockId;
    delete newFormValues?.plotId;
    delete newFormValues?.lineId;
    delete newFormValues?.areaGraveId;
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;

    let blocks = context?.contextBlocks;
    let plots = context?.contextPlots;
    let rows = [];

    if (event?.target?.value && event.target.value !== null && event.target.value !== '') {
      blocks = getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', event.target.value);
      plots = context?.contextPlots.filter((plot) => blocks.some((block) => block?.unicId === plot.blockId));
    }
    setBlocks(fullSelectedBlocks(blocks));
    setPlots(fullSelectedPlots(plots));
    setRows(rows);
  };
  const fieldChangeBlockId = (event, newFormValues) => {
    delete newFormValues?.plotId;
    delete newFormValues?.lineId;
    delete newFormValues?.areaGraveId;
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;

    let cemeteryId = newFormValues?.cemeteryId;

    let blocks = fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', newFormValues?.cemeteryId));
    let plots = fullSelectedPlots(context?.contextPlots.filter((plot) => blocks.some((block) => block?.unicId === plot.blockId)));
    let rows = [];

    if (event?.target?.value && event.target.value !== null && event.target.value !== '') {
      plots = fullSelectedPlots(getEntitiesByAttr(context?.contextPlots, 'blockId', event.target.value));
      blocks = fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'unicId', event.target.value));

      const block = getEntityByAttr(context?.contextBlocks, 'unicId', event.target.value);

      cemeteryId = block?.cemeteryId;
    }
    setPlots(plots);
    setRows(rows);
    return { cemeteryId };
  };
  const fieldChangePlotId = (event, newFormValues) => {
    delete newFormValues?.lineId;
    delete newFormValues?.areaGraveId;
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;

    let cemeteryId = newFormValues?.cemeteryId;
    let blockId = newFormValues?.blockId;

    let blocks = fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'unicId', newFormValues?.blockId));
    let rows = [];
    let areaGraves = fullSelectedAreaGraves(getEntitiesByAttr(context?.contextAreaGraves, 'plotId', newFormValues?.areaGraveId));

    let plot = getEntityByAttr(context?.contextPlots, 'unicId', newFormValues?.plotId);

    if (event?.target?.value && event.target.value !== null && event.target.value !== '') {
      plot = getEntityByAttr(context?.contextPlots, 'unicId', event.target.value);

      cemeteryId = plot?.cemeteryId;
      blockId = plot?.blockId;

      blocks = fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'unicId', plot?.blockId));
      rows = fullSelectedRows(getEntitiesByAttr(context?.contextRows, 'plotId', event.target.value), true, setOpen);
      areaGraves = fullSelectedAreaGraves(getEntitiesByAttr(context?.contextAreaGraves, 'plotId', event.target.value));
    }

    setBlocks(blocks);
    setRows(rows);
    setAreaGraves(areaGraves);

    return { ...newFormValues, blockId, cemeteryId };
  };
  const fieldChangeLineId = (event, newFormValues) => {
    delete newFormValues?.areaGraveId;
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;

    let cemeteryId = newFormValues?.cemeteryId;
    let blockId = newFormValues?.blockId;
    let plotId = newFormValues?.plotId;

    let blocks = fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'unicId', newFormValues?.blockId));
    let plots = fullSelectedPlots(getEntitiesByAttr(context?.contextPlots, 'unicId', newFormValues?.plotId));
    let rows = fullSelectedRows(getEntitiesByAttr(context?.contextRows, 'plotId', newFormValues?.plotId), true, setOpen);
    let areaGraves = fullSelectedAreaGraves(getEntitiesByAttr(context?.contextAreaGraves, 'unicId', newFormValues?.areaGraveId));

    let row = getEntityByAttr(context?.contextRows, 'unicId', newFormValues?.lineId);

    if (event?.target?.value && event.target.value !== null && event.target.value !== '') {
      row = getEntityByAttr(context?.contextRows, 'unicId', event.target.value);

      cemeteryId = row?.cemeteryId;
      blockId = row?.blockId;
      plotId = row?.plotId;

      blocks = fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'unicId', row?.blockId));
      plots = fullSelectedPlots(getEntitiesByAttr(context?.contextPlots, 'unicId', row?.plotId));
      rows = fullSelectedRows(getEntitiesByAttr(context?.contextRows, 'plotId', row?.plotId), true, setOpen);
      areaGraves = fullSelectedAreaGraves(getEntitiesByAttr(context?.contextAreaGraves, 'lineId', event.target.value));
    }

    return {
      ...newFormValues,
      cemeteryId,
      blockId,
      plotId,
      areaGraves
    };
  };

  // קבלת הקומות
  const getFloorAttributes = (obj) => {
    return Object.keys(obj)
      .filter((key) => key.startsWith('floor'))
      .reduce((result, key) => {
        result[key] = obj[key];
        return result;
      }, {});
  };
  // הסרת הקומות
  const removeFloorAttributes = (obj) => {
    const newObj = { ...obj };
    Object.keys(newObj).forEach((key) => {
      if (key.startsWith('floor')) {
        delete newObj[key];
      }
    });
    return newObj;
  };
  // הפיכה לאובייקט
  const convertToObjectArray = (obj) => {
    return Object.keys(obj)
      .filter((key) => key.startsWith('floor'))
      .map((key) => ({
        // unicId: uuidv4(),
        areaGraveId: myAreaGrave?.unicId,
        ...obj[key]
      }));
  };
  // בודק אם נעשה שינוי בקומת הקבר הקיימת
  const hasChanges = (originalGrave, updatedGrave) => {
    if (!originalGrave || !updatedGrave) return true; // אם אחד מהם ריק, נחשב כשינוי
    return originalGrave.plotType !== updatedGrave.plotType || originalGrave.graveNameHe !== updatedGrave.graveNameHe;
  };
  // קבלת הקברים המוסרים מהרשימה
  const getUniqueItems = (arr1, arr2) => {
    const idsInArray2 = arr2?.map((item) => item?.unicId);
    return arr1?.filter((item) => !idsInArray2?.includes(item?.unicId));
  };
  //לוגיקת הזנה בשדות הטופס
  const handleChange = (event) => {
    let newFormValues = formValues;
    const { name, value } = event.target;

    if (name === 'addFloor') {
      // השדות של הקברים שמתווספים
      let columnsGraves = [];
      // let data = getEntityByAttr(context?.contextAreaGraves, 'unicId', formValues?.id);
      let data = myAreaGrave;

      // מציאת הערך האחרון של name
      const getLastFloorNumber = (arr) => {
        // Iterate over each item in the array
        const floorNumbers = arr.map((item) => {
          // Find the key that starts with 'floor'
          const floorKey = Object.keys(item).find((key) => key.startsWith('floor'));

          // Extract the number from the key
          if (floorKey) {
            const match = floorKey.match(/^floor(\d+)$/);
            return match ? parseInt(match[1], 10) : 0;
          }
          return 0;
        });

        // Return the maximum number found
        return Math.max(...floorNumbers);
      };

      // // פונקציה למציאת האות העברית האחרונה לפי יוניקוד
      const getLastHebrewLetter = (arr) => {
        const hebrewLetters = arr.map((item) => {
          const key = Object.keys(item).find((k) => k.startsWith('floor'));
          return key ? item[key].graveNameHe.charCodeAt(item[key].graveNameHe.length - 1) : 0;
        });

        const maxUnicode = Math.max(...hebrewLetters);
        const nextLetter = String.fromCharCode(maxUnicode + 1);

        return nextLetter;
      };

      let temp = Object.keys(formValues)
        .filter((key) => key.startsWith('floor'))
        .map((key) => ({ [key]: formValues[key] }));

      const lastFloorNumber = getLastFloorNumber(temp);
      const lastHebrewLetterCode = getLastHebrewLetter(temp);

      // פונקציה להוספת הערך החדש
      const addNewFloor = () => {
        const newFloor = {
          id: Date.now(), // או כל דרך אחרת לייצר id ייחודי
          name: `floor${lastFloorNumber + 1}`,
          graveNameHe: lastHebrewLetterCode,
          required: true,
          width: 800,
          show: true,
          input: 'floors',
          notRepeat: true
        };
        data = {
          ...data,
          [`floor${lastFloorNumber + 1}`]: { plotType: 1, graveNameHe: lastHebrewLetterCode }
        };
        columnsGraves = [...columnsGraves, newFloor];
      };

      // הוספת הערך החדש למערך
      addNewFloor();

      setFieldsWithDynamicDisabled(myColumns([...fieldsWithDynamicDisabled, ...columnsGraves]));

      setFormValues({ ...formValues, [`floor${lastFloorNumber + 1}`]: { plotType: 1, graveNameHe: lastHebrewLetterCode } });
      return;
    }
    if (name === 'cemeteryId') {
      let res = fieldChangeCemeteryId(event, newFormValues);
    }
    if (name === 'blockId') {
      let res = fieldChangeBlockId(event, newFormValues);
      if (event.target.value !== '') {
        newFormValues = { ...newFormValues, cemeteryId: res?.cemeteryId };
      }
    }
    if (name === 'plotId') {
      let res = fieldChangePlotId(event, newFormValues);
      newFormValues = { ...newFormValues, cemeteryId: res?.cemeteryId, blockId: res?.blockId };
    }
    if (name === 'lineId') {
      let res = fieldChangeLineId(event, newFormValues);
    }
    setFormValues({ ...newFormValues, [name]: value });
  };
  // אימות ערכים
  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    let areaGraves = context?.contextCemeteries?.filter((areaGrave) => areaGrave?.unicId !== formValues?.id);

    columns.forEach((field) => {
      if (field.required && !formValues[field.name]) {
        if (field.name !== 'addFloor') {
          tempErrors[field.name] = 'שדה חובה';
          formIsValid = false;
        }
        if (field.name === 'addFloor') {
          if (!Object.keys(getFloorAttributes(formValues)).length > 0) {
            tempErrors[field.name] = 'חובה להקים קומה אחת לפחות';
            formIsValid = false;
          }
        }
      }

      if (field.notRepeat && formValues[field.name]) {
        if (areaGraves.some((item) => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };
  // שליחת הטופס
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      setLoadingData(true);
      let newFormValues = { ...formValues };

      // הסרת הקומות מתוך מערך areGrave
      newFormValues = removeFloorAttributes(newFormValues);

      let tempAddGraves = [];
      let tempUpdateGraves = [];
      let tempRemoveGraves = [];

      delete newFormValues?.addFloor;
      delete newFormValues?.cemeteryNameHe;
      delete newFormValues?.blockNameHe;
      delete newFormValues?.plotNameHe;
      delete newFormValues?.cemeteryId;
      delete newFormValues?.blockId;
      delete newFormValues?.plotId;

      // קבלת מערך כל הקברים המקושרים - לפני העדכון
      let gravesBeforeUpdate = getEntitiesByAttr(context?.contextGraves, 'areaGraveId', myAreaGrave?.unicId);

      // קבלת כל הקברים המקורים - אחרי העדכון
      const gravesAfterUpdate = convertToObjectArray({ ...formValues })?.map((grave) => {
        // בדיקה אם האייטם קיים ב-context?.contextGraves
        let tempGrave = context?.contextGraves?.find((g) => g?.unicId === grave?.unicId);

        if (tempGrave) {
          // אם האייטם קיים, מעדכנים אותו עם השינויים
          tempGrave = {
            ...tempGrave,
            plotType: grave?.plotType,
            graveNameHe: grave?.graveNameHe
          };

          // בדיקה אם יש שינויים בין האובייקט המקורי לזה שעודכן
          const originalGrave = gravesBeforeUpdate?.find((beforeGrave) => beforeGrave?.unicId === tempGrave?.unicId);

          if (hasChanges(originalGrave, tempGrave)) {
            // אם יש שינויים, מוסיפים ל-tempUpdateGraves
            tempUpdateGraves?.push(tempGrave);
          }
        } else {
          // אם האייטם לא קיים ב-context?.contextGraves, מדובר בערך חדש
          tempAddGraves?.push({
            ...grave, // מוסיפים את האייטם כפי שהוא
            graveStatus: 1,
            unicId: uuidv4(),
          });
        }

        if (grave && grave?.unicId) {
          return grave;
        }
      });

      // חילוץ הקברים שהוסרו מתוך הקברים המקוריים
      const gravesRemove = getUniqueItems(gravesBeforeUpdate, gravesAfterUpdate)?.map((graveRemove) => {
        let tempGrave = context?.contextGraves?.find((grave) => grave?.unicId === graveRemove?.unicId);
        if (tempGrave) {
          tempGrave = {
            ...tempGrave,
            plotType: graveRemove?.plotType,
            graveNameHe: graveRemove?.graveNameHe,
            isAction: false
          };
        }
        tempRemoveGraves.push(tempGrave);

        if (graveRemove && graveRemove?.unicId) {
          return { ...graveRemove, isActive: false };
        }
      });

      // הוספת הקומות לערך שנשלח לשרת
      const updatedFormValues = {
        ...newFormValues,
        insertGraves: tempAddGraves,
        updateGraves: tempUpdateGraves,
        removeGraves: gravesRemove
      };

      let res = await addOrUpdateDataAreaGrave(updatedFormValues);

      if (res === 200) {
        updateRecordInCache(newFormValues, 'dataAreaGraves');

        context?.setContextAreaGraves((prev) => {
          // בדיקה אם הערך קיים בסטייט
          const existingIndex = prev.findIndex((item) => item.unicId === newFormValues.unicId);

          if (existingIndex !== -1) {
            // אם הערך קיים, מעדכן אותו
            const updatedState = [...prev];
            updatedState[existingIndex] = { ...updatedState[existingIndex], ...newFormValues };

            return updatedState;
          } else {
            // אם הערך לא קיים, מוסיף אותו
            return [...prev, newFormValues];
          }
        });        

        context?.setContextGraves((prev) => {
          // העתקת הסטייט הנוכחי למערך חדש
          const updatedState = [...prev];
          
          tempRemoveGraves?.forEach((item) => {
            // קריאה לפונקציה deleteRecordFromCache עם האייטם
            deleteRecordFromCache(item, 'dataGraves');

            // הסרה מהסטייט לפי unicId
            const indexToRemove = updatedState.findIndex((record) => record.unicId === item.unicId);

            if (indexToRemove !== -1) {
              updatedState.splice(indexToRemove, 1); // הסרה מהמערך לפי אינדקס
            }            
          });

          tempUpdateGraves?.forEach((item) => {
            // קריאה לפונקציה updateRecordInCache עם האייטם
            updateRecordInCache(item, 'dataGraves');

            // עדכון או הוספה לסטייט
            const existingIndex = updatedState.findIndex((record) => record.unicId === item.unicId);
            if (existingIndex !== -1) {
              updatedState[existingIndex] = { ...updatedState[existingIndex], ...item }; // עדכון אובייקט קיים
            } else {
              updatedState.push(item); // הוספת אובייקט חדש
            }
          });

          tempAddGraves?.forEach((item) => {
            // קריאה לפונקציה addRecordToCache עם האייטם
            addRecordToCache(item, 'dataGraves');

            // הוספה לסטייט
            const existingIndex = updatedState.findIndex((record) => record.unicId === item.unicId);
            if (existingIndex === -1) {
              updatedState.push(item); // הוספה אם לא קיים
            }
          });
          // החזרת הסטייט המעודכן
          
          return updatedState;
        });

        setLoadingData(false);
        navigate(-1);
      } else {
        console.error('Error updating area grave');
      }
    }
  };
  // הסרת קומת קבר
  const deleteItem = (item) => {
    const tempColumns = fieldsWithDynamicDisabled.filter((p) => p?.name !== item?.name);

    let checkEntity = getEntityByAttr(context?.contextBurials, 'graveId', item?.unicId) || getEntityByAttr(context?.contextPurchases, 'graveId', item?.unicId);

    if (checkEntity) {
      alert('לא ניתן להסיר, קיים תיק מקושר');
    } else {
      setFieldsWithDynamicDisabled(myColumns(tempColumns));
      setFormValues((prev) => {
        let temp = { ...prev };
        delete temp[item.name];
        return temp;
      });
    }
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
        const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
        const dataPlots = localTempData.find((item) => item.name === 'dataPlots');
        const dataRows = localTempData.find((item) => item.name === 'dataRows');
        const dataAreaGraves = localTempData.find((item) => item.name === 'dataAreaGraves');
        const dataGraves = localTempData.find((item) => item.name === 'dataGraves');
        const dataPurchases = localTempData.find((item) => item.name === 'dataPurchases');
        const dataBurials = localTempData.find((item) => item.name === 'dataBurials');
        if (dataCemeteries && dataBlocks && dataPlots && dataRows && dataAreaGraves && dataGraves && dataPurchases && dataBurials) {
          setLoading(false);
        }
      }
      const handlePartialUpdate = (tableName) => {
        console.log(`Partial update received for table: ${tableName}`);
        setLoading(false);
      };
      // fetchDataServerWithCallback(['cemeteries', 'blocks', 'plots', 'rows', 'areaGraves', 'graves'], token, handlePartialUpdate);

      fetchDataServer(['purchases', 'burials'], token);
    }
    loadTableData();
  }, []);

  if (loading || loadingData) return <LoadingOverlay />;

  return (
    <>
      <FormTemplate
        title={`עריכת ${NAME_ENTITY}`}
        btn={`עדכן`}
        fields={fieldsWithDynamicDisabled}
        columns={fieldsWithDynamicDisabled}
        formValues={formValues}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        del={deleteItem}
        errors={errors}
        options={{
          cemeteryId: cemeteries,
          blockId: blocks,
          plotId: plots,
          lineId: rows,
          graveType: getFieldOptions('graveType', optionsFields)
        }}
      />
      <CustomDialog open={open} handleClose={() => setOpen(false)} title={'הוספת שורה'}>
        <RowCreate plotId={formValues?.plotId || ''} />
      </CustomDialog>
      <p>
        <span style={{ fontFamily: "'Courier New', Courier, monospace" }}>עדכון קבר</span>
      </p>
    </>
  );
}

export default GraveUpdate;
